export function getRecoveryRedirectUrl() {
  if (typeof window === 'undefined') {
    throw new Error('Password recovery is only available in the CutScript browser app.');
  }

  const url = new URL(window.location.href);

  if (
    url.protocol !== 'https:' ||
    ['localhost', '127.0.0.1', '::1'].includes(url.hostname)
  ) {
    throw new Error(
      'Password recovery is disabled on local or insecure URLs. Open the hosted CutScript app before requesting a reset.'
    );
  }

  url.search = '';
  url.hash = '';
  url.searchParams.set('recovery', '1');

  return url.toString();
}
